import React from "react";
import ButtonProject from "../assets/buttonproject.svg";
import GymControlLogo from "../assets/gymcontrol.png";

interface IButtonDark {
  isDarkMode: Boolean;
}

const projects = [
  {
    id: 1,
    name: "Nutri - (Em Desenvolvimento)",
    description: "Aplicativo para auxiliar Nutricionistas",
    image:
      "https://cdn.dribbble.com/users/9798633/screenshots/18574398/media/7b07a09f043d3e9097756cb8e80a2ff4.jpg?compress=1&resize=400x300",
    url: "https://github.com/pablokaue2004/Nutri",
  },
  {
    id: 2,
    name: "Clone Whatsapp - (Em Desenvolvimento)",
    description:
      "Clone do Whatsapp web usando Metarial UI para componentização",
    image: "https://img.ibxk.com.br/2015/01/22/22112321034230.jpg",
    url: "https://github.com/pablokaue2004/CloneByWhatsapp",
  },
  {
    id: 3,
    name: "Clone Controlle - (Completo)",
    description: "Clone do Controller site usado para controle financeiro",
    image: "https://controlle.com/images/og.png",
    url: "https://github.com/pablokaue2004/CloneByControlle",
  },
  {
    id: 4,
    name: "Crud Angular - (Completo)",
    description: "Simples Crud em angular",
    image:
      "https://1.bp.blogspot.com/-vzLK_eeymGo/YQ4CTJBQl_I/AAAAAAAAI9I/0uUM9gz4GsMuW-QuZma42OuhWDREYcAkACLcBGAsYHQ/s1567/spring%2Bboot%2Bangular%2Bfull%2Bstack%2Bapplication%2B-%2Blist%2Bemployees.png",
    url: "https://github.com/pablokaue2004/crud-angular.io",
  },
  {
    id: 5,
    name: "Mail Queue - (Completo)",
    description: "Sistema de envio de email com fila",
    image:
      "https://www.getmailbird.com/assets/themes/mb1/imgs/misc/laptop.webp",
    url: "https://github.com/pablokaue2004/MailQueue",
  },
  {
    id: 7,
    name: "Gym Control - (Completo)",
    description: "Sistema de controle para academias",
    image: GymControlLogo,
    url: "https://github.com/pablokaue2004/gym_control",
  },
];

export const Projects = () => {
  return (
    <div className="tw-flex tw-h-auto tw-flex-col tw-items-center tw-justify-evenly md:tw-justify-between tw-py-10 md:tw-py-20 tw-px-8 md:tw-px-16 lg:tw-px-32 xl:tw-px-64">
      <p className="tw-font-bold tw-text-5xl tw-text-[#D0E8F4]">Projetos</p>
      <div className="tw-max-w-[750px]">
        <p className="tw-font-normal tw-text-base tw-text-[#94ABBD] tw-text-center tw-my-6">
          Como desenvolvedor de sistemas, tive a oportunidade de participar de
          diversos projetos desafiadores que contribuíram significativamente
          para o meu crescimento profissional. Separei os melhores projetos para
          exibir aqui, espero que gostem :)
        </p>
      </div>
      <div className="tw-grid tw-grid-rows-2 md:tw-grid-flow-col md:tw-grid-rows-2 tw-gap-4">
        {projects.map((item) => (
          <div
            key={item.id}
            className="col-span-2 tw-w-[350px] tw-h-[500px] tw-bg-[#1E283F] tw-rounded-xl tw-p-4"
          >
            <img className="tw-w-full tw-h-64 tw-rounded-xl" src={item.image} alt="" />
            <div className="tw-h-40">
              <p className="tw-font-bold tw-text-lg tw-text-[#D0E8F4]">
                {item.name}
              </p>
              <p className="tw-font-normal tw-text-base tw-text-[#D0E8F4] tw-my-5">
                {item.description}
              </p>
            </div>
            <a target="_blank" href={item.url}>
              <img className="tw-w-36" src={ButtonProject} alt="" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
